import React, { useEffect } from 'react'

const toltipExist = tooltipElem => typeof window !== 'undefined' && tooltipElem
const isTooltipUpperWindow = top => top < 0
const isTooltipUnderWindowViewport = bottom => bottom > window.innerHeight
const isTooltipOutLeftViewport = left => left < 0
const isTooltipOutRightViewport = right => right > window.innerWidth

const useTooltipPosition = ({
  isOpen,
  tooltipElem,
  initialPosition,
  initialTooltipAlign
}) => {
  const [position, setPosition] = React.useState(initialPosition)
  const [tooltipAlign, setTooltipAlign] = React.useState(initialTooltipAlign)

  useEffect(
    () => {
      if (toltipExist(tooltipElem)) {
        const elementAsABox = tooltipElem.getBoundingClientRect()
        const { bottom, left, right, top, width, height } = elementAsABox

        if (isTooltipUpperWindow(top)) {
          setPosition('bottom')
        } else if (isTooltipUnderWindowViewport(bottom)) {
          setPosition('top')
        }

        if (isTooltipOutLeftViewport(left)) {
          setTooltipAlign('right')
        } else if (isTooltipOutRightViewport(right)) {
          setTooltipAlign('left')
        }
      }
    },
    [isOpen, tooltipElem]
  )

  return { position, tooltipAlign }
}

export default useTooltipPosition
